import { getAsyncLifecycle, defineConfigSchema, getSyncLifecycle } from '@openmrs/esm-framework';
import { configSchema } from './config-schema';
import { createDashboardLink } from '@openmrs/esm-patient-common-lib';
import { dashboardMeta } from './dashboard.meta';

export const moduleName = '@icap-ethiopia/esm-ethiohri-ict-app';

const options = {
  featureName: 'index-case-testing',
  moduleName,
};

export const importTranslation = require.context('../translations', false, /.json$/, 'lazy');

export function startupApp() {
  defineConfigSchema(moduleName, configSchema);
}

export const ictService = getAsyncLifecycle(() => import('./ict-service/index'), options);
export const root = getAsyncLifecycle(() => import('./root.component'), options);

export const ictServiceDashboardLink = getSyncLifecycle(
  createDashboardLink({
    ...dashboardMeta,
    moduleName,
  }),
  options,
);
export const ictInformationFrom = getAsyncLifecycle(() => import('./forms/index-case-information-form'), options);
export const ictOfferForm = getAsyncLifecycle(() => import('./forms/index-case-offering-form'), options);
export const elicitedContactForm = getAsyncLifecycle(() => import('./forms/elicited-contact-form'), options);

export const encounterDeleteConfirmation = getAsyncLifecycle(() => import('./utils/Delete-Encounter.modal'), options);
